/* eslint-disable no-empty */
import { createRouter, createWebHistory, RouteRecordRaw, NavigationGuard } from 'vue-router';

import store from '@/store';

import Login from '../pages/login/Login.vue';
import Redeem from '../pages/redeem/Redeem.vue';
import ForgotPassword from '../pages/forgot-password/ForgotPassword.vue';
/* import ChangePassword from '../pages/change-password/ChangePassword.vue'; */
import Layout from '../pages/layout/Layout.vue';

import Overview from '../pages/overview/Overview.vue';
/* import Devices from '../pages/devices/Devices.vue'; */
/* import Stats from '../pages/stats/Stats.vue'; */
import NotFound from '../pages/notfound/NotFound.vue';

const requireAuth: NavigationGuard = async (to, from, next) => {
    try {
        const result = await store.dispatch('auth/verifyUser');
        if (result === true) {
            next();
            return;
        }
    } catch {}

    next({
        name: 'login',
        query: {
            redirect: to.fullPath,
        },
    });
};

const requireNotAuth: NavigationGuard = async (to, from, next) => {
    try {
        const result = await store.dispatch('auth/verifyUser');
        if (result === true && !to.fullPath.includes('authorize')) {
            next({
                name: 'home',
            });
            return;
        }
    } catch {}

    next();
};

const routes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: requireNotAuth,
    },
    {
        path: '/authorize',
        name: 'authorize',
        component: Redeem,
        beforeEnter: requireNotAuth,
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        beforeEnter: requireNotAuth,
    },
    {
        path: '/',
        component: Layout,
        beforeEnter: requireAuth,
        children: [
            {
                path: '/',
                name: 'home',
                component: Overview,
            },
            {
                path: '/maps',
                name: 'maps',
                component: () => import('../pages/maps/Maps.vue'),
            },
            /* {
                path: '/reports',
                name: 'reports',
                component: () => import('../pages/reports/Reports.vue'),
            }, */
            /* {
                path: '/stats',
                name: 'stats',
                component: Stats,
            }, */
            /* {
                path: '/temperature-dashboard2',
                name: 'temperature-dashboard2',
                component: TemperatureDashboard2,
            }, */
            /* {
                path: '/change-password',
                name: 'change-password',
                component: ChangePassword,
            }, */
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notfound',
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
